// extracted by mini-css-extract-plugin
export default {"label":"FormFieldLabel_label__kEYpC","icon":"FormFieldLabel_icon__MVexG"};